import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPostById, createPost, updatePost, deletePost } from "../services/api";

function PostForm() {
  const { id } = useParams();  // Lấy id từ URL
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [contentMd, setContentMd] = useState("");
  const [coverImage, setCoverImage] = useState(null);
  const [coverImageUrl, setCoverImageUrl] = useState("");
  const [isPublished, setIsPublished] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Load dữ liệu nếu đang sửa
  useEffect(() => {
    if (isEdit) {
      getPostById(id)
        .then((res) => {
          const post = res.data;
          setTitle(post.title);
          setExcerpt(post.excerpt);
          setContentMd(post.content_md);
          setCoverImageUrl(post.cover_image_url);
          setIsPublished(post.is_published);
        })
        .catch(() => setError("Không thể tải bài viết."));
    }
  }, [id, isEdit]);

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError("");

  try {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("excerpt", excerpt);
    formData.append("content_md", contentMd);
    formData.append("is_published", isPublished);
    if (coverImage) {
      formData.append("cover_image", coverImage);
    }

    if (isEdit) {
      await updatePost(id, formData);
      navigate("/tin-tuc", { state: { message: "Cập nhật bài viết thành công!" } });
    } else {
      await createPost(formData);
      navigate("/tin-tuc", { state: { message: "Tạo bài viết thành công!" } });
    }

    // navigate("/admin/posts");
  } catch (err) {
    setError(err.response?.data?.error || "Đã có lỗi xảy ra");
  } finally {
    setLoading(false);
  }
};

  const handleDelete = async () => {
    if (!window.confirm("Bạn chắc chắn muốn xoá bài viết này?")) return;

    try {
      await deletePost(id);
      navigate("/tin-tuc", { state: { message: "Xoá bài viết thành công!" } });
    } catch (err) {
      setError("Xoá thất bại");
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-4 bg-white shadow rounded">
      <h2 className="text-xl font-bold mb-4">{isEdit ? "Chỉnh sửa bài viết" : "Tạo bài viết mới"}</h2>

      {error && <div className="text-red-500 mb-2">{error}</div>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          className="w-full border p-2"
          placeholder="Tiêu đề"
          value={title || ""}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <textarea
          className="w-full border p-2"
          placeholder="Tóm tắt (excerpt)"
          value={excerpt || ""}
          onChange={(e) => setExcerpt(e.target.value)}
          required
        />

        <textarea
          className="w-full border p-2 h-40"
          placeholder="Nội dung Markdown"
          value={contentMd || ""}
          onChange={(e) => setContentMd(e.target.value)}
          required
        />

        <div>
          <label className="block mb-1 font-medium">Ảnh bìa:</label>
          <input type="file" accept="image/*" onChange={(e) => setCoverImage(e.target.files[0])} />
          {coverImageUrl && (
            <img src={coverImageUrl} alt="cover" className="mt-2 h-40 object-cover rounded" />
          )}
        </div>

        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={isPublished}
            onChange={(e) => setIsPublished(e.target.checked)}
          />
          <span>Xuất bản bài viết</span>
        </label>

        <div className="flex space-x-4">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            disabled={loading}
          >
            {loading ? "Đang lưu..." : "Lưu"}
          </button>

          {isEdit && (
            <button
              type="button"
              onClick={handleDelete}
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Xoá
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default PostForm;